export enum OrderBy {
    Series,
    LargestToSmallest,
    SmallestToLargest
}
